/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable quote-props */
/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  FilterSettingsModel,
  GridComponent,
  PageSettingsModel,
  TextWrapSettingsModel,
} from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs, MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent, DialogUtility } from '@syncfusion/ej2-angular-popups';
import { Subscription } from 'rxjs';
import { EmitType } from '@syncfusion/ej2-base';
import { AssetDocument } from 'src/app/models/assetdocument.model';
import { ApiService } from 'src/app/services/api.service';
import { WasabiService } from 'src/app/services/wasabi.service';
import { DocTypeView } from 'src/app/models/docTypeView.model';
import { Client } from 'src/app/models/client.model';
import { DocTypeCategory } from 'src/app/models/docTypeCategory.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { FileViewerService } from 'src/app/services/fileviewer.service';
import { ModalController } from '@ionic/angular';
import { AddLocalDocumentComponent } from '../add-local-document/add-local-document.component';
import { EventItemComponent } from '../event-item/event-item.component';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { StoreService } from 'src/app/services/store.service';
interface TreeNode {
  id: string;
  name: string;
  fullPath: string,
  type: 'directory' | 'directory-with-folders' | 'file';
  folderType: string | null;
  subChild: TreeNode[];
  counts: number;
  fileData?: any; // Optional, store file metadata if needed
  reviewStatus?:any;
}

@Component({
  selector: 'app-asset-documents',
  templateUrl: './asset-documents.component.html',
  styleUrls: ['./asset-documents.component.scss'],
})
export class AssetDocumentsComponent implements OnInit, OnDestroy {
  @Input() assetSN: string;
  @Input() assetId: string | number;
  @Input() assetType: string | number;
  @Input() folderNodeId?: string | number = null;
  @Input() isAdmin: boolean;
  @Input() client: Client;
  @Input() sectionType?: string = null;
  @Input() eventId?: string = null;

  public documentList: AssetDocument[] = [];
  public docSub: Subscription;
  public docTypeSub: Subscription;
  public docTypeCatSub: Subscription;
  public docTypeCategories: DocTypeCategory[] = [];
  public pageSettings: PageSettingsModel;
  public wrapSettings: TextWrapSettingsModel;
  public filterOption: FilterSettingsModel = { type: 'Menu' };
  public toolbar: object[];
  public dialogVisibility = false;
  public fileLocation: string = '';
  // public parentType: string;
  public contextMenuItems: MenuItemModel[];
  public assetDocTypeViewList: DocTypeView[] = [];
  public documentDownload: boolean = false;

  public menuItems: MenuItemModel[] = [
    {
      text: 'Download',
      iconCss: 'e-icons e-download'
    }];

  assetsDocList: any;
  fileterdAssetDocList: any;
  public docTypeViewFullList: any[] = [];
  public fields: Object = { text: 'clientName', value: 'clientID' };
  // public assetFields: Object;
  public assetFields: Object;
  public assetDocuments: AssetDocument[] = [];
  public assetTypeName: string;
  public selectedNode: string = '';
  public isBulkUpload: Boolean = false;
  public editData: any;
  public showLoading: boolean = true;
  public loading: number = 0;
  public documentView = false;
  folderPath: Array<any> = [];
  selectedFile: any = {};
  returnFromUploadingComponent: boolean = false;
  public searchText: string = '';
  public documentDelete: boolean = false;
  approval: string | null = null;
  approvalComment: string = '';
  selectedFolder: any
  @ViewChild('docgrid') public grid: GridComponent;
  @ViewChild('documentDialog') dialogObject!: DialogComponent;
  public awdbSub: Subscription;
  localFolderId: any
  userRoleId = JSON.parse(localStorage.getItem('user'))?.roleId;

  // configurable: how many total items to show (including last). E.g. 4 -> show first 2, dropdown, last
  maxVisible = 3;

  startItems: any[] = [];    // items shown at start (left)
  overflowItems: any[] = []; // items put into dropdown (middle)
  lastItem: any = null;
  reviewStatusDropdown:any=['approved','approved with exception','discrepancy identified','discrepancy responded','pending review']
  reviewStatusValue:any=''
  statusClasses: any = {
  'pending review': 'tw-bg-gray-500',
  'discrepancy identified': 'tw-bg-red-500',
  'discrepancy responded': 'tw-bg-orange-500',
  'approved': 'tw-bg-green-800',
  'approved with exception': 'tw-bg-green-500'
};

assetSummaryMode:string=''
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private wasabiService: WasabiService,
    public apiService: ApiService,
    public storeService: StoreService,
    private snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    public fileViewService: FileViewerService,
    private modalController: ModalController
  ) {
    this.searchText = '';
  }

  ngOnChanges() {

  }

  onApprovalChange(event: any) {
    this.approval = event.value;
    this.approvalComment = '';
  }

  onApprovalCommentChange(event: any) {
    this.approvalComment = event.target.value;
  }

  @HostListener('window:resize')
  onResize() {
    // If you want to vary maxVisible with window size, update it here then call recalculate()
    // e.g. this.maxVisible = window.innerWidth < 600 ? 3 : 4;
    this.recalculate();
  }

  private recalculate() {
    const list = Array.isArray(this.folderPath) ? this.folderPath : [];
    const total = list.length;

    if (total === 0) {
      this.startItems = [];
      this.overflowItems = [];
      this.lastItem = null;
      return;
    }

    // If items fit within maxVisible -> show them all (no dropdown)
    if (total <= this.maxVisible) {
      this.startItems = list.slice(0, total - 1); // all except last
      this.overflowItems = [];
      this.lastItem = list[total - 1];
      return;
    }

    // If path too long -> show first (maxVisible - 2), then dropdown (middle), then last.
    // Example: maxVisible=4 -> show first 2 (index 0,1), dropdown contains index 2..(n-2), last is index n-1
    // const numStart = this.maxVisible - 2;
    this.startItems = [this.folderPath[0]];
    this.overflowItems = list.slice(1, total - 1);
    this.lastItem = list[total - 1];
  }

  truncate(name: string) {
    if (!name && name !== '') return '';
    const s = String(name);
    return s.length > 30 ? s.slice(0, 30) + '...' : s;
  }
  userRole: any
  getRoleViewData() {
    this.docSub = this.apiService.getRoleById(this.userRoleId).subscribe(
      (data) => {
        this.userRole = data
      },
      (err) => {
        this.apiService.openErrorSnackBar(
          err?.error?.error ? err?.error?.error : 'Please contact support team',
          null
        );
        this.router.navigate(
  [`/assets/${this.getAssetTypeName(this.assetType).toLowerCase()}/${this?.assetId}`],
  { queryParams: { mode: this.assetSummaryMode,index:0 } }
);
      })
  }
  onSelectContextMenu(args: any, source: any): void {
    switch (args.item.text) {
      case 'Download':
        this.loading++;
        console.log('Download action triggered', source, this.assetType, this.assetId);
        this.apiService.downloadAssetDocumentsDirectory({
          assetTypeId: this.assetType,
          assetId: this.assetId,
          folderNodeId: [source.id]
        }, 'documentsDirectory').subscribe((res) => {
          this.handleDownloadFile(res);
        }, (err) => {
          this.loading--;
        });
        break;
    }
  }

  downloadAssetDocumentsDirectories(): void {
    this.loading++;
    this.apiService.downloadAssetDocumentsDirectory({
      assetTypeId: this.assetType,
      assetId: this.assetId
    }, 'assetDocumentsDirectories').subscribe((res) => {
      this.handleDownloadFile(res);
    }, (err) => {
      this.loading--;
    });
  }
  downloadAssetDocumentsDirectoriesWithAttachedAssets(): void {
    this.loading++;
    this.apiService.downloadAssetDocumentsDirectory({
      assetTypeId: this.assetType,
      assetId: this.assetId
    }, 'assetDocumentsDirectoriesWithAttachedAssets').subscribe((res) => {
      this.handleDownloadFile(res);
    }, (err) => {
      this.loading--;
    });
  }

  handleDownloadFile(response) {
    if (response.type === 'application/json') {
      response.text().then(res => {
        const jsonResponse = JSON.parse(res);
        this.apiService.openSnackBar(jsonResponse.message);
        this.apiService.getDownloads().subscribe(response => {
          console.log("Setting downloads in assets api", response);
          this.storeService.updateState({ downloads: response });
        });
      }).catch(err => {
        console.log("Error parsing response: ", err);
      });
    }
    else if (response.type === 'application/x-zip') {
      const blob = new Blob([response], {
        type: 'application/x-zip',
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${this.getAssetTypeName(this.assetType)}_${this.assetSN}_${new Date().toISOString()}.zip`;
      link.click();
      link.remove();
    }
    this.loading--;
  };
  hasAddPermission(valueCheck: any): boolean {
    if (this.userRole) {
      let resource = this.userRole?.formatted_permissions.find((p) => p.resource_name === 'Assets')?.children?.find((c) => c.resource_name === 'Documents');
      if(this.sectionType === 'MULTIMEDIA'){
        resource = resource?.children?.find((c) => c.resource_name === 'Pictures & Videos')
      }
      else{
         resource = resource?.children?.find((c) => c.resource_name === 'Asset Documents')
      }
      return valueCheck === 'add' ? !!resource?.can_add : valueCheck === 'delete' ? !!resource?.can_delete : valueCheck === 'edit' ? !!resource?.can_edit : valueCheck === 'explore' ? !!resource?.can_explore : valueCheck === 'read' ? !!resource?.can_read : false;
    }
  }

  public openSnackBar(message: string, action: string = 'Cancel') {
    this.snackBar.open(message, action, {
      duration: 2000, // duration in milliseconds
      horizontalPosition: 'center', // horizontal position of the snack bar
      verticalPosition: 'bottom', // vertical position of the snack bar
      panelClass: ['custom-snackbar'], // custom CSS class
    });
  }

  public ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {
      if(params?.mode){
          this.assetSummaryMode = params?.mode
      }
    })
    this.loading = 0;
    this.getRoleViewData();
    this.getData();
    this.pageSettings = { pageSize: 25 };
    this.wrapSettings = { wrapMode: 'Content' };
    // if (this.isAdmin === true){
    this.toolbar = [
      { text: 'Bulk Upload', tooltipText: 'Bulk Upload', prefixIcon: 'e-upload', id: 'bulk' },
      { text: 'Upload Document', tooltipText: 'Upload Document', prefixIcon: 'e-upload', id: 'add' },
    ];

    this.folderPath.push({
      index: -1,
      name: 'Home',
      originalFileName: 'Home'
    });

    this.contextMenuItems = [
      { text: 'View', id: 'view' },
      { text: 'Edit', id: 'edit' },
      { text: 'Comment', id: 'comment' },
      { text: 'Delete', id: 'delete', iconCss: 'e-icons e-delete' },
    ];

    if (this.assetType === 1) {
      this.fileLocation = this.client.clientID + '/MSN';
    } else {
      if (this.assetType === 2) {
        this.fileLocation = this.client.clientID + '/ENG';
      } else {
        if (this.assetType === 3) {
          this.fileLocation = this.client.clientID + '/APU';
        } else {
          if (this.assetType === 4) {
            this.fileLocation = this.client.clientID + '/LG';
          } else {
            this.fileLocation = this.client.clientID + '/PROP';
          }
        }
      }
    }
    this.getDocTypeCategories();
    this.recalculate();


  }

  public ngOnDestroy(): void {
    if (this.docSub !== null && this.docSub !== undefined) {
      this.docSub.unsubscribe();
    }
    if (this.docTypeSub !== null && this.docTypeSub !== undefined) {
      this.docTypeSub.unsubscribe();
    }
    if (this.docTypeCatSub !== null && this.docTypeCatSub !== undefined) {
      this.docTypeCatSub.unsubscribe();
    }
    if (this.awdbSub !== null && this.awdbSub !== undefined) {
      this.awdbSub.unsubscribe();
    }
  }

  public hideDialog: EmitType<object> = () => {
    this.dialogObject.hide();
    this.dialogVisibility = false;
  };

  folderSelected(source: any, i: number): void {
    if (source?.subChild?.length > 0 && source.subChild.some((e: any) => e.type?.includes('directory'))) {
      // If the selected folder has subdirectories
      this.fileterdAssetDocList = source.subChild;
      if (!this.folderPath.some((fp) => fp.name === source.name)) {
        this.selectedFolder = source
        this.folderPath.push({ index: i, name: source.name, id: source?.id, originalFileName: source.name });
      }
    } else if (source.type === 'file') {
      // If the selected item is a file
      this.selectedFile = source;
      this.approval = source.approvalStatus;
      this.approvalComment = source.comment;
      this.downloadFile(this.selectedFile, this.selectedFile?.uploadedFileUrl)
    } else {
      this.selectedFolder = source;
      // For folders without directories
      this.folderPath.push({ index: i, name: source.name, id: source?.id, originalFileName: source.name });
      this.fileterdAssetDocList = source.subChild;
      if (source.subChild?.length > 0) {
        if (source.subChild[0]?.length === 0) {
          this.fileterdAssetDocList = [];
        }
      }
    }
    this.recalculate();

  }

  uploadFile(): void {
    this.isBulkUpload = true;
  }
  downloadDocument(): void {
    const fileUrl: string = this.selectedFile.uploadedFileUrl;
    this.openOrDownloadFile(fileUrl);
    // this.downloadFile(this.fileLocation, filename, filename);
  }

  openOrDownloadFile(fileUrl: string) {
    this.documentDownload = true;
    console.log(this.folderPath)
    console.log(fileUrl)
    // Extract and process the filename
    let fileName = decodeURI(fileUrl.split('/').pop() || 'download');
    // fileName = this.getProcessedFileName(fileName); // Apply filename processing

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName; // Use the processed filename

    // Attempt to download the file using fetch if it's a cross-origin URL
    fetch(fileUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('File download failed');
        }
        return response.blob();
      })
      .then((blob) => {
        // Create a Blob URL and trigger the download
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.click();
        // Clean up the Blob URL after download
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error('Error downloading file:', error);
        // Fallback to opening the file directly if the download fails
        window.open(fileUrl, '_blank');
      })
      .finally(() => {
        this.documentDownload = false;
      });
  }

  // comment(): void {
  //   sessionStorage.setItem('selectedFeedback', JSON.stringify(this.selectedFile));
  //   sessionStorage.setItem('previousRoute', window.location.href);
  //   this.router.navigate(['/feedback']);
  //   this.close();
  // }
  async addItem(selectedFile: any) {
    const modal = await this.modalController.create({
      component: EventItemComponent,
      componentProps: { type: 'Add', eventId: this.eventId, assetObj: { assetTypeId: this?.assetType, assetId: this?.assetId }, documentId: selectedFile?.id },//Fetch event ID from query param and pass it here
      backdropDismiss: true,
    });

    modal.onDidDismiss().then((result) => {
      if (result.data && result.data.dismissed) {
        this.applyRefreshGetApiCall()
      }
      this.close();
    });

    // 🔥 Get ONLY this modal’s element
    const modalElement = modal;

    // 🔥 Style ONLY this modal
    modalElement.style.setProperty('--width', '60%');
    modalElement.style.setProperty('--height', '45%');
    modalElement.style.setProperty('max-width', '100%');
    modalElement.style.setProperty('max-height', '100%');
    modalElement.style.setProperty('margin', 'auto');
    modalElement.style.setProperty('display', 'flex');
    modalElement.style.setProperty('flex-direction', 'column');
    modalElement.style.setProperty('justify-content', 'center');
    modalElement.style.setProperty('align-items', 'center');

    // 🔥 Style BACKDROP only for THIS modal
    const backdrop = modalElement.shadowRoot
      ?.querySelector('.modal-wrapper ion-backdrop') as HTMLElement;

    if (backdrop) {
      backdrop.style.setProperty('backdrop-filter', 'blur(10px)');
      backdrop.style.setProperty('background-color', 'rgba(0, 0, 0, 0.4)');
    }
    await modal.present();
  }

  async saveItem(selectedFile) {

    if (this.eventId) {
      this.apiService.updateOilEventDocumentStatus({
        eventId: this.eventId,
        assetId: selectedFile.assetId,
        assetTypeId: selectedFile.assetTypeId,
        assetDocId: selectedFile.id,
        approvalStatus: this.approval,
        comment: this.approvalComment
      }).subscribe((res: any) => {
        console.log("Updated event document!", res);
        this.applyRefreshGetApiCall();
        this.close();
      }, (err: any) => {
        this.showLoading = false;
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      }), (err: any) => {
        this.showLoading = false;
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      };
    }
    console.log('selectedFile', selectedFile, this.eventId, this.approval, this.approvalComment);
  }

  close(): void {
    this.selectedFile = {};
  }
  changeDirectory(path: { index: number; name: string }, i: number): void {
    // Update folderPath to the selected breadcrumb
    this.folderPath = this.folderPath.slice(0, i + 1); // Keep the path up to the selected breadcrumb

    if (path.index === -1) {
      // If Home is clicked, reset to root
      this.fileterdAssetDocList = this.assetsDocList;
    } else {
      // Traverse the assetsDocList based on the updated folderPath
      let tempFiles = this.assetsDocList;

      for (let j = 1; j < this.folderPath.length; j++) {
        const currentFolder = tempFiles[this.folderPath[j].index];
        this.selectedFolder = currentFolder;
        if (currentFolder?.subChild) {
          tempFiles = currentFolder.subChild;
        } else {
          console.error('Invalid folder structure at:', this.folderPath[j].name);
          break;
        }
      }

      this.fileterdAssetDocList = tempFiles || [];
    }
    this.recalculate();

  }

  public dialogButton: Object = [
    {
      click: this.hideDialog.bind(this),
      buttonModel: {
        content: 'Cancel',
      },
    },
  ];

  applySearch(): void {
    if (!this.searchText) {
      this.folderPath = [];
      this.folderPath.push({
        index: -1,
        name: 'Home',
        originalFileName: 'Home'
      });
      this.getData();
    }
  }
  applyRefreshGetApiCall(reviewStastusApply=false) {
    this.searchText = '';
    this.assetDocuments = [];
    this.assetDocTypeViewList = [];
    if (this.folderPath && this.folderPath.length > 0) {
      this.returnFromUploadingComponent = true;
      const lastFolder = this.folderPath[this.folderPath.length - 1];
      if (lastFolder.index === -1) {
        // Home folder
        this.fileterdAssetDocList = this.assetsDocList;
      }
    } else {
      this.returnFromUploadingComponent = false;
      this.folderPath = [];
      this.folderPath.push({
        index: -1,
        name: 'Home',
        originalFileName: 'Home'
      });
    }
    if(reviewStastusApply === false){
      this.reviewStatusValue = []
    }
    this.getData();
  }
  public getAssetTypeName(assetId): string {
    switch (Number(assetId)) {
      case 1:
        return 'Aircraft'
      case 2:
        return 'Engine'
      case 3:
        return 'APU'
      case 4:
        return 'Landing Gear'
      case 5:
        return 'Propeller'
      case 6:
        return 'Component'
    }
  }
  public getData(selectedNode = 'none'): void {
    console.log('runs')
    this.showLoading = true;
    let data = {
      assetTypeId: this.assetType,
      assetId: this.assetId,
      recordId: 0,
    };
    if (this.searchText) {
      data['filenameFilter'] = this.searchText;
    }
    if (this.sectionType) {
      data['sectionType'] = this.sectionType;
    }
    if (this.folderNodeId) {
      data['folderNodeId'] = [Number(this.folderNodeId)]
    }
    if (this.eventId) {
      data["eventId"] = this.eventId;
    }
    if(this.reviewStatusValue?.length > 0){
      data["reviewStatus"] = this.reviewStatusValue.join(', ');
    }
    console.log(data)
    try {
      // switch (this.assetType) {
      //   case 1:
      this.assetTypeName = this.getAssetTypeName(this.assetType);
      if (this.eventId) {
        this.docSub = this.apiService
          .getEventDocumentsByEventId(data)
          .subscribe((res: AssetDocument[] | boolean) => {
            try {
              if (res !== false) {
                this.documentList = res as [];
                this.assetDocuments = [];
                console.log("Gt res", this.documentList);

                if (selectedNode !== 'none') {
                  this.assetDocuments = this.documentList?.filter((o) => o.title.toUpperCase() === selectedNode);
                }
                //this.getDocTypeView();
              }
              this.fileterdAssetDocList = [];
              this.assetDocTypeViewList = [];

              this.assetsDocList = [];
              if (!this.searchText) {
                this.setTreeView();
              } else {
                this.folderPath = [];
                if (this.documentList) {
                  for (let i = 0; i < this.documentList.length; i++) {
                    const treeNode = this.documentList[i];
                    this.fileterdAssetDocList.push({
                      ...treeNode,
                      type: 'file',
                    });
                  }
                  this.returnFromUploadingComponent = false;
                  this.showLoading = false;
                }
              }
            } catch (err: any) {
              console.error('Could not load asset docs data ', err);
            }
          }, (err: any) => {
            this.showLoading = false;
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403){
              this.router.navigate(
    [`/assets/${this.getAssetTypeName(this.assetType).toLowerCase()}/${this?.assetId}`],
    { queryParams: { mode: this.assetSummaryMode,index:0 } }
  );
            }
          }), (err: any) => {
            this.showLoading = false;
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403){
              this.router.navigate(
    [`/assets/${this.getAssetTypeName(this.assetType).toLowerCase()}/${this?.assetId}`],
    { queryParams: { mode: this.assetSummaryMode,index:0 } }
  );
            }
          };
      }
      else {
        this.docSub = this.apiService
          .getDocumentsByAssetTypeId(data)
          .subscribe((res: AssetDocument[] | boolean) => {
            try {
              if (res !== false) {
                this.documentList = res as [];
                this.assetDocuments = [];

                if (selectedNode !== 'none') {
                  this.assetDocuments = this.documentList?.filter((o) => o.title.toUpperCase() === selectedNode);
                }
                //this.getDocTypeView();
              }
              this.fileterdAssetDocList = [];
              this.assetDocTypeViewList = [];

              this.assetsDocList = [];
              if (!this.searchText) {
                this.setTreeView();
              } else {
                this.folderPath = [];
                if (this.documentList) {
                  for (let i = 0; i < this.documentList.length; i++) {
                    const treeNode = this.documentList[i];
                    this.fileterdAssetDocList.push({
                      ...treeNode,
                      type: 'file',
                    });
                  }
                  this.returnFromUploadingComponent = false;
                  this.showLoading = false;
                }
              }
            } catch (err: any) {
              console.error('Could not load asset docs data ', err);
            }
          }, (err: any) => {
            this.showLoading = false;
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403){
              this.router.navigate(
    [`/assets/${this.getAssetTypeName(this.assetType).toLowerCase()}/${this?.assetId}`],
    { queryParams: { mode: this.assetSummaryMode,index:0 } }
  );
            }
          }), (err: any) => {
            this.showLoading = false;
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
            if(err?.status === 403){
              this.router.navigate(
    [`/assets/${this.getAssetTypeName(this.assetType).toLowerCase()}/${this?.assetId}`],
    { queryParams: { mode: this.assetSummaryMode,index:0 } }
  );
            }
          };
      }
    } catch (err) {
      this.showLoading = false;
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      if(err?.status === 403){
        this.router.navigate(
    [`/assets/${this.getAssetTypeName(this.assetType).toLowerCase()}/${this?.assetId}`],
    { queryParams: { mode: this.assetSummaryMode,index:0 } }
  );
            }
    }
  }

  buildPrefixFromPath(path: string, condition?: string): string {
    const segments = path?.split('/');
    const prefixParts: string[] = [];

    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i].trim();
      if (!segment) continue;

      const firstWord = segment.split(' ')[0];

      prefixParts.push(firstWord);
      // if (i === 0) {
      //   // Always include the first word from the first segment
      // prefixParts.push(firstWord);
      // } else {
      //   // Include only if it's numeric
      //   if (/^\d+$/.test(firstWord)) {
      //     prefixParts.push(firstWord);
      //   }
      // }
    }

    // Join segments with '.' while ensuring:
    // - no extra dots if a segment already ends with dot
    // - no trailing dot at the end
    return prefixParts
      .map((word, index) => {
        if (segments?.length === 1 && condition === 'file') {
          if (word.endsWith('.')) {
            return word.slice(0, -1)
          }
          else {
            return word
          }
        }
        const isLast = prefixParts.length == 1 ? false : index === prefixParts.length - 1;
        return word.endsWith('.') ? word.slice(0, -1) + (isLast ? '' : '.') : word + (isLast ? '' : '.');
      })
      .join('');
  }
  removeFirstWord(segment: string): string {
    const words = segment.trim().split(' ');
    return words.slice(1).join(' ');
  }
  buildTreeNode(node: any): TreeNode {
    const hasChildren = node.children && Object.keys(node.children).length > 0;
    const hasFiles = node.files && Object.keys(node.files).length > 0;

    const newNode: TreeNode = {
      id: node.id,
      fullPath: node.fullPath,
      name: this.buildPrefixFromPath(node.fullPath) + ' ' + this.removeFirstWord(node.name),
      type: 'directory',
      folderType: node.folderType,
      subChild: [],
      counts: 0, // will be calculated below
      reviewStatus:node.reviewStatus
    };

    // Step 1: Process files directly under this node
    if (hasFiles) {
      for (const fileKey in node.files) {
        if (node.files.hasOwnProperty(fileKey)) {
          const file = node.files[fileKey];
          const fileNameWithoutType = file.origFileName.substring(0, file.origFileName.lastIndexOf('.'));
          const fileType = file.origFileName.substring(file.origFileName.lastIndexOf('.'));
          const formattedFileName =
            this.buildPrefixFromPath(node.fullPath, 'file') + '-' +
            file.dateIssued.replace(/-/g, '') + '-' +
            fileNameWithoutType + '-' +
            file.assetSN.replace(' ', '-') +
            fileType;
          const fileNode: any = {
            ...file,
            fileName: formattedFileName,
            type: 'file',
            reviewStatus:file?.reviewStatus
          };
          newNode.subChild.push(fileNode);
          newNode.counts += 1; // count only files directly under this node
        }
      }
    }

    // Step 2: Process child folders recursively
    if (hasChildren) {
      for (const childKey in node.children) {
        if (node.children.hasOwnProperty(childKey)) {
          const child = node.children[childKey];
          const childNode = this.buildTreeNode(child);
          newNode.subChild.push(childNode);
          newNode.counts += childNode.counts; // Add child count to parent count
        }
      }
    }

    // Step 3: Assign type based on content
    if (newNode.subChild.length === 0) {
      newNode.type = 'directory';
    } else if (hasChildren && hasFiles) {
      newNode.type = 'directory-with-folders';
    } else if (hasChildren && !hasFiles) {
      newNode.type = 'directory-with-folders';
    } else if (!hasChildren && hasFiles) {
      newNode.type = 'directory-with-folders';
    } else if (!hasChildren && !hasFiles) {
      newNode.type = 'directory';
    }

    return newNode;
  }

  public setTreeView(): void {
    this.assetDocTypeViewList = [];

    for (const key in this.documentList) {
      if (this.documentList.hasOwnProperty(key)) {
        const rawNode = this.documentList[key];
        const treeNode = this.buildTreeNode(rawNode);
        this.assetDocTypeViewList.push(treeNode);
      }
    }

    this.assetFields = {
      dataSource: this.assetDocTypeViewList,
      id: 'id',
      text: 'name',
      child: 'subChild',
    };

    this.assetsDocList = this.assetDocTypeViewList;

    if (!this.returnFromUploadingComponent) {
      this.fileterdAssetDocList = this.assetDocTypeViewList;
    } else {
      this.updateContentBasedOnFolderPath();
    }
    this.returnFromUploadingComponent = false;
    this.showLoading = false;
  }

  getFileCount(subChild: any[]): number {
    if (!subChild) return 0;
    return subChild.filter((s) => s.type === 'file').length;
  }
  public checkforDocs(doctypeName: string): boolean {
    if (this.documentList.length > 0) {
      for (let i in this.documentList) {
        if (doctypeName.toUpperCase() === this.documentList[i].title.toUpperCase()) {
          return true;
        }
      }
    }
    return false;
  }

  public contextMenuClick(args: any): void {
    if (args.item.id === 'view') {
      const filename: string[] = this.grid.getSelectedRecords().map((e) => e['fileName']);
      // this.downloadFile(this.fileLocation, filename, filename[0]);
    }
    if (args.item.id === 'edit') {
      let rowIdx = args.rowInfo.rowIndex;
      let data = this.assetDocuments[rowIdx];
      this.editData = data;
      this.dialogVisibility = true;
      try {
        this.dialogObject.show();
      } catch { }
    }
    if (args.item.id === 'delete') {
      this.onOpenDialog();
    }

    if (args.item.id === 'comment') {
      let row = args.rowInfo.rowData;
      sessionStorage.setItem('selectedFeedback', JSON.stringify(row));
      sessionStorage.setItem('previousRoute', window.location.href);
      this.router.navigate(['/feedback']);
    }
  }

  public deleteDocument(): void {
    const id: string[] = this.selectedFile.id;
    const filename: string[] = this.selectedFile.fileName;
    const dtd = {
      clientID: JSON.parse(localStorage.getItem('client'))?.clientID,
      section: this.sectionType,
      recordId: id,
    };
    try {
      // switch (this.assetType) {
      //   case 1:
      (this.docSub = this.apiService.deleteDoc(dtd).subscribe(
        (data) => {
          this.apiService.openSnackBar('Successfully Deleted', null);
          this.assetDocuments = [];
          this.assetDocTypeViewList = [];
          this.wasabiService.deleteFile(this.fileLocation + '/' + this.assetSN, filename[0]);
          this.returnFromUploadingComponent = true;
          this.getData();
          this.DialogObj.hide();
          this.documentDelete = false;
        },
        (err) => {
          this.documentDelete = false;
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err) => {
          this.documentDelete = false;
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.documentDelete = false;
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }

    this.close();
  }

  public toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'add') {
      // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.dialogVisibility = true;
      try {
        this.dialogObject.show();
      } catch { }
    }
    if (args.item.id === 'bulk') {
      // 'Grid_excelexport' -> Grid component id + _ + toolbar item name

      this.isBulkUpload = true;
      // this.dialogVisibility = true;
      // try {
      //   this.dialogObject.show();
      // } catch { }
    }
  }

  public resetAndClose(event: any): void {
    this.isBulkUpload = false;
  }

  public updateContentBasedOnFolderPath(): void {
    let tempFiles = this.assetsDocList;
    this.folderPath.forEach((folder) => {
      if (folder.index !== -1 && tempFiles[folder.index]?.subChild) {
        tempFiles = tempFiles[folder.index].subChild;
      }
    });
    this.fileterdAssetDocList = tempFiles || [];
    if (this.fileterdAssetDocList && this.fileterdAssetDocList.length > 0) {
      if (this.fileterdAssetDocList[0]?.length === 0) {
        this.fileterdAssetDocList = [];
      }
    }
  }

  public dismissModal(data: { dataSaved: boolean; folderPath?: any[] } = { dataSaved: false }): void {
    try {
      this.modalController?.dismiss({
        dismissed: false,
      });
      this.dialogObject?.hide();
      this.editData = null;
    } catch (err) {
      console.error('Error hiding dialog:', err);
    }

    this.dialogVisibility = false;
    this.returnFromUploadingComponent = data.dataSaved;
    if (data.dataSaved === true) {
      this.assetDocuments = [];
      this.assetDocTypeViewList = [];

      if (data.folderPath && data.folderPath.length > 0) {
        this.folderPath = data.folderPath;

        // Fetch content for the last folder in the folderPath
        const lastFolder = this.folderPath[this.folderPath.length - 1];
        if (lastFolder.index === -1) {
          // Home folder
          this.fileterdAssetDocList = this.assetsDocList;
        }
      } else {
        // Default to Home folder
        this.folderPath = [
          {
            index: -1,
            name: 'Home',
            originalFileName: 'Home'
          },
        ];
        this.fileterdAssetDocList = this.assetsDocList;
      }

      this.getData(); // Ensure data is refreshed
    }
  }

  public recordDoubleClick(args): void {
    let file: string[] = [];
    file.push(args.rowData.fileName);
    // this.downloadFile(this.fileLocation, file, args.rowData.fileName);
  }

  hasValidImageExtension(filename: string): boolean {
    // Get the extension from the filename
    const validExtensions: string[] = ['.jpg', '.jpeg', '.png', '.svg', '.gif', 'doc', 'docx', 'xls', 'xlsx', 'txt'];
    const extension = filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
    return validExtensions.includes('.' + extension);
  }

  public async downloadFile(selectedFile: any, url: string) {
    const addItemsData = { type: 'Add', eventId: this.eventId, assetObj: { assetTypeId: this?.assetType, assetId: this?.assetId }, documentId: selectedFile?.id ,itemId: selectedFile?.oilItemId}
    const modal = await this.modalController.create({
      component: DocumentViewerComponent,
      componentProps: { iframeSrc: url, addItemsData,
        folderNodeId:this.folderNodeId,
        selectedFile:selectedFile,
        sectionType:this.sectionType,
        assetType:this.assetType,
        client:this.client,
        assetSN:this.assetSN
       },//Fetch event ID from query param and pass it here
      cssClass: 'document-viewer',
      backdropDismiss: false,
    });

    modal.onDidDismiss().then((result) => {
       if (result.data && result.data.dismissed) {
        this.applyRefreshGetApiCall();
        this.close();
        // Refresh document list or perform another action
      }
      // this.close();
    });

    await modal.present();
    // we use this downloadFile(folder: string, fileName: string, fn: string,url:string) if we uncomment s3 code
    // const bucket = new S3({
    //   accessKeyId: environment.WSaccessKeyId,
    //   secretAccessKey: environment.WSsecretAccessKey,
    //   region: environment.WSregion,
    //   endpoint: environment.WSendpoint
    // });

    // const params = {
    //   Bucket: environment.WSBucket,
    //   Key: folder + '/' + this.assetSN.replace(' ', '-') + '/' + fileName
    // };

    // const handleError = (err) => {
    //   this.openSnackBar(err.message ? err.message : err);
    // };

    // const handleData = (err, data) => {
    //   if (err) {
    //     handleError(err);
    //     return;
    //   }

    // const binaryData = [];
    // binaryData.push(data.Body);
    // const objectData = new Blob(binaryData, { type: data.ContentType });

    // const file = new File([objectData], fn, {
    //   type: objectData.type,
    // });
    // this.documentView = true;
    //  const fileExtension = url.split('.').pop()?.toLowerCase();
    //   if (fileExtension === 'pdf') {
    //     //file.name.toLowerCase().includes('pdf') for s3 code
    //     //code will be in no need if we uncomment above s3 code that start here
    //     const response = await fetch(url);
    //     if (!response.ok) {
    //       this.documentView = false;
    //       throw new Error(`Failed to fetch file: ${response.statusText}`);
    //     }

    //     const blob = await response.blob();
    //     const file = new File([blob], fileName, { type: blob.type });
    //     // end here
    //     const url1 = window.URL.createObjectURL(file);
    //     window.open(url1);
    //     this.documentView = false;
    //   } else if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(fileExtension)) {
    //     // open a new tab with an HTML wrapper for better control
    //     const htmlContent = `
    //   <html>
    //     <head>
    //       <title>${fileName}</title>
    //       <style>
    //         body {
    //           margin: 0;
    //           background-color: #f9f9f9;
    //           display: flex;
    //           justify-content: center;
    //           align-items: center;
    //           height: 100vh;
    //         }
    //         img {
    //           max-width: 90vw;
    //           max-height: 90vh;
    //           object-fit: contain;
    //           border: 1px solid #ccc;
    //           box-shadow: 0 0 10px rgba(0,0,0,0.2);
    //         }
    //       </style>
    //     </head>
    //     <body>
    //       <img src="${url}" alt="Image preview" />
    //     </body>
    //   </html>
    // `;

    //     const blob = new Blob([htmlContent], { type: 'text/html' });
    //     const htmlUrl = URL.createObjectURL(blob);
    //     window.open(htmlUrl);
    //     this.documentView = false;
    //   } else {
    //     this.fileViewService.loadDocument(url);
    //     this.documentView = false;
    //   }

    // else if (this.hasValidImageExtension(file.name)) {
    //   const link = document.createElement('a');
    //   const url = URL.createObjectURL(file);
    //   window.open(url)
    // }
    // else {
    //   const link = document.createElement('a');
    //   const url = URL.createObjectURL(file);
    //   link.href = url;
    //   link.download = file.name;
    //   document.body.appendChild(link);
    //   link.click();

    //   document.body.removeChild(link);
    //   window.URL.revokeObjectURL(url);
    //   this.openSnackBar("File Started to Download");
    //   }
    // };

    // bucket.getObject(params, handleData.bind(this)).on('httpDownloadProgress', (progress) => {
    //   // Optionally handle download progress here
    // });
  }

  public DialogObj;

  public onOpenDialog = function (): void {
    // const filename: string[] = this.grid.getSelectedRecords().map((e) => e['title']);
    const filename = this.selectedFile.fileName;
    this.DialogObj = DialogUtility.confirm({
      title: 'Delete Confirmation',
      content: 'Delete document ' + filename + ' ?',
      okButton: { text: 'OK', click: this.okClick.bind(this) },
      cancelButton: { text: 'Cancel', click: this.cancelClick.bind(this) },
      showCloseIcon: true,
      closeOnEscape: true,
      animationSettings: { effect: 'Zoom' },
    });
  };

  public onNodeSelected(args) {
    if (args.nodeData.parentID != null) {
      this.assetDocuments = this.documentList.filter((o) => o.title.toUpperCase() === args.nodeData.text.toUpperCase());
      this.selectedNode = args.nodeData.text.toUpperCase();
    }
  }

  public getDocTypeCategories(): void {
    let data = {
      id: 0,
      wit: 'all',
      assetId: this.assetId,
      assetTypeID: this.assetType,
    };
    this.docTypeCatSub = this.apiService.getDocTypeCategories(data).subscribe((data1) => {
      // if (data1 !== null) {
      //   console.log({data1})
      //   this.docTypeCategories = data1.filter(o => o.AssetTypeID == this.assetType);
      // }
    });
  }

  private okClick(): void {
    this.documentDelete = true;
    this.deleteDocument();
    this.DialogObj.hide();
  }

  private cancelClick(): void {
    //Hide the dialog
    this.DialogObj.hide();
  }

  extractFolderFromUrl(url: string): string {
    // Extract the folder path between the domain and the file name
    const urlObj = new URL(url); // Parse the URL
    const pathSegments = urlObj.pathname.split('/'); // Split path by '/'
    return pathSegments.slice(1, -1).join('/'); // Remove empty segment, keep folder structure
  }

  formatFileSize(sizeInBytes: number): string {
    let fileSize = Number(sizeInBytes);
    if (fileSize !== 0) {
      if (fileSize < 1024) {
        return `${fileSize} Bytes`;
      } else if (fileSize < 1024 * 1024) {
        return `${(fileSize / 1024).toFixed(2)} KB`;
      } else if (fileSize < 1024 * 1024 * 1024) {
        return `${(fileSize / (1024 * 1024)).toFixed(2)} MB`;
      } else {
        return `${(fileSize / (1024 * 1024 * 1024)).toFixed(2)} GB`;
      }
    } else {
      return 'Undefinded File Size';
    }
  }

  public async addLocalFolder(args?: any, event?: any): Promise<void> {
    if (event) {
      event.stopPropagation();
    }
    const modal = await this.modalController.create({
      component: AddLocalDocumentComponent,
      cssClass: 'add-local-document-folder',
      componentProps: {
        data: args || null,
        assetTypeId: this.assetType,
        assetsId: Number(this.assetId),
        documentId: this.folderPath?.length > 1 ? this.folderPath[this.folderPath?.length - 1]?.id : null,
        folderType: 1,
        status: 'local',
        sectionType:this.sectionType
        // documentType: this.folderPath?.length === 1 ? 'Header' : this.folderPath?.length === 2 ? 'Category' : 'Type',
      },
    });
    await modal.present();
    modal.onDidDismiss().then((result) => {
      if (result.data && result.data.dismissed) {
        this.applyRefreshGetApiCall();
        // Refresh document list or perform another action
      }
    });
  }
  public localFolderDialogObj;
  public onOpenLocalFolderDeleteDialog = function (id: any, event: any): void {
    if (event) {
      event.stopPropagation();
    }
    this.localFolderId = id
    this.localFolderDialogObj = DialogUtility.confirm({
      title: 'Delete Confirmation',
      content: 'Delete selected Local Folder?',
      okButton: { text: 'OK', click: this.deleteLocalFolder.bind(this) },
      cancelButton: { text: 'Cancel', click: this.cancelLocalFolder.bind(this) },
      showCloseIcon: true,
      closeOnEscape: true,
      animationSettings: { effect: 'Zoom' }
    });
  };

  private deleteLocalFolder(): void {

    this.awdbSub = this.apiService.deleteDocumentFolder(this.localFolderId).subscribe((data1) => {
      this.localFolderId = null
      this.apiService.openSnackBar('Data Deleted Successfully', null)
      this.localFolderDialogObj.hide();
      this.applyRefreshGetApiCall();
    }, (err) => {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      this.localFolderDialogObj.hide();
    }), (err) => {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      this.localFolderDialogObj.hide();
    };

  }

  private cancelLocalFolder(): void {
    //Hide the dialog
    this.localFolderDialogObj.hide();
  }
  onRowSelected(args: any) {
  const source = args.data;
  const index = args.rowIndex;
  this.folderSelected(source, index);
}
isAllSelected(): boolean {
  return this.reviewStatusValue.length > 0 && this.reviewStatusDropdown.every(f => this.reviewStatusValue.includes(f));
}

toggleSelectAll(): void {
  this.reviewStatusValue = this.isAllSelected() ? [] : [...this.reviewStatusDropdown];
}
}
